import React from 'react';
import './styles.scss';
import { Upload } from 'antd';

const { Dragger: DraggerAntd } = Upload;

const Dragger = ({ children, ...rest }) => {
  const draggerDefaultProps = {
    multiple: true,
    showUploadList: false,
    customRequest: () => {},
  };

  return (
    <DraggerAntd {...draggerDefaultProps} {...rest}>
      {children}
    </DraggerAntd>
  );
};

export default Dragger;
